var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details-component"},[_c('div',{staticClass:"details-component__header"},[_c('h1',[_vm._v(_vm._s(_vm.$t('common.products')))])]),_vm._v(" "),(_vm.products.items)?_c('div',{staticClass:"details-component__content content"},[_c('v-client-table',{staticClass:"mobile-1050",attrs:{"data":_vm.products.items,"columns":_vm.columns,"options":_vm.options}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d35b8f1a","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/zones/ProductsTable.vue
// module id = 1528
// module chunks = 65